export default __webpack_public_path__ + "images/a2eb4b9f4ee7f13a1506fd7bd99e2977-easter.webp";